import { render, staticRenderFns } from "./commodities.vue?vue&type=template&id=8474a3f8&scoped=true"
import script from "./commodities.vue?vue&type=script&lang=js"
export * from "./commodities.vue?vue&type=script&lang=js"
import style0 from "./commodities.vue?vue&type=style&index=0&id=8474a3f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8474a3f8",
  null
  
)

export default component.exports